import {
	APP_HOST_NAME,
	LOCAL_HOST_NAME,
	SHARE_HOST_NAME,
	WEB_APP_HOST_NAME_SUFFIX,
} from 'core/constants/constants';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

function SubdomainRedirect({ isShareMode }) {
	const location = useLocation();
	useEffect(() => {
		// NOTE: This is a temporary solution to short circuit redirection in development mode
		if (
			!window.location.hostname ||
			window.location.hostname?.includes(WEB_APP_HOST_NAME_SUFFIX) ||
			window.location.hostname?.includes(LOCAL_HOST_NAME)
		)
			return;

		if (window.location.hostname?.includes(SHARE_HOST_NAME) && !isShareMode) {
			window.location.assign(`https://${APP_HOST_NAME}`);
		}
		if (!window.location.hostname?.includes(SHARE_HOST_NAME) && isShareMode) {
			window.location.assign(`https://${SHARE_HOST_NAME}/${window.location.pathname}`);
		}
	}, [isShareMode, location]);
	return <Outlet />;
}

export default SubdomainRedirect;
